<template>
  <div
    class="position-fixed mb-0 d-flex align-items-start alert fade resident-anno-alert"
    :class="[isAlertShow ? 'show' : 'event-none']"
    role="alert"
  >
    <i v-if="false" class="me-2 mc-info resident-anno-alert-info"></i>
    <div class="me-3" v-html="residentAnno && residentAnno.content"></div>
    <button
      aria-label="Close"
      type="button"
      class="ms-auto resident-anno-alert-close"
      @click="isAlertShow = false"
    >
      <i class="mc-close d-inline-block"></i>
    </button>
  </div>
</template>

<script>
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  useStore,
  watch
} from '@nuxtjs/composition-api'
import { from, catchError, filter, tap } from 'rxjs'
import useLocale from '../../composables/useLocale'
import useErrorHandler from '../../composables/useErrorHandler'

export default defineComponent({
  setup(props, context) {
    const store = useStore()

    const isAlertShow = ref(false)
    const residentAnno = computed(() => store.state.annoModule.residentAnno)

    const { locale } = useLocale()
    watch(locale, () => {
      if (isAlertShow.value) {
        getResidentAnno$().subscribe()
      }
    })

    onMounted(() => {
      getResidentAnno$()
        .pipe(
          filter(() => residentAnno.value),
          tap(() => (isAlertShow.value = true))
        )
        .subscribe()
    })

    const { errorHandler$ } = useErrorHandler(context)

    function getResidentAnno$() {
      return from(store.dispatch('getResidentAnno')).pipe(
        catchError(err => errorHandler$(err))
      )
    }

    return {
      residentAnno,
      isAlertShow
    }
  }
})
</script>
